import React from 'react';
import displayName from 'component-lib/displayName';
import styles from './DocumentViewer.scss';
import DocumentViewer from './DocumentViewer';

function DocumentViewerContainer(props) {
    return (<div data-document-viewer="true">
        <div className={styles['dv-overlay']} />
        <DocumentViewer {...props} />
    </div>)
}

DocumentViewerContainer.displayName = displayName('DocumentViewer/Container');

export default DocumentViewerContainer;
